export const symptoms = [
  "Fiebre (temperatura mayor a 38 °C)",
  "Dolor de garganta",
  "Congestión nasal",
  "Tos",
  "Dificultad para respirar",
  "Fatiga",
  "Escalofrio",
  "Dolor muscular",
  "Convive o ha tenido contacto cercano en los últimos 14 días (a menos de 2 metros y por más de 15 minutos) con alguien diagnosticado con COVID-19 o en proceso de diagnóstico",
  "Pérdida de gusto",
  "Pérdida de olfato",
  "Diarrea",
];
